export default "__VITE_ASSET__CoVqGaQZ__"